import { Icon, IconProps } from "../";

export const FactCheckIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5ZM5.5 16C5.5 15.5858 5.83579 15.25 6.25 15.25H9.75C10.1642 15.25 10.5 15.5858 10.5 16C10.5 16.4142 10.1642 16.75 9.75 16.75H6.25C5.83579 16.75 5.5 16.4142 5.5 16ZM6.25 11.25C5.83579 11.25 5.5 11.5858 5.5 12C5.5 12.4142 5.83579 12.75 6.25 12.75H9.75C10.1642 12.75 10.5 12.4142 10.5 12C10.5 11.5858 10.1642 11.25 9.75 11.25H6.25ZM5.5 8C5.5 7.58579 5.83579 7.25 6.25 7.25H9.75C10.1642 7.25 10.5 7.58579 10.5 8C10.5 8.41421 10.1642 8.75 9.75 8.75H6.25C5.83579 8.75 5.5 8.41421 5.5 8ZM18.5303 11.0303C18.8232 10.7374 18.8232 10.2626 18.5303 9.96967C18.2374 9.67678 17.7626 9.67678 17.4697 9.96967L15 12.4393L13.5303 10.9697C13.2374 10.6768 12.7626 10.6768 12.4697 10.9697C12.1768 11.2626 12.1768 11.7374 12.4697 12.0303L14.4697 14.0303C14.7626 14.3232 15.2374 14.3232 15.5303 14.0303L18.5303 11.0303Z"
      />
    </Icon>
  );
};
